import React from 'react';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
}

export function H1({ children, className = '' }: TypographyProps) {
  return (
    <h1 className={`text-h1 font-sans font-bold tracking-tighter uppercase ${className}`}>
      {children}
    </h1>
  );
}

export function H2({ children, className = '' }: TypographyProps) {
  return (
    <h2 className={`text-h2 font-sans font-bold tracking-tighter uppercase ${className}`}>
      {children}
    </h2>
  );
}

export function Body({ children, className = '' }: TypographyProps) {
  return (
    <p className={`text-base font-sans leading-relaxed ${className}`}>
      {children}
    </p>
  );
}

export function Label({ children, className = '' }: TypographyProps) {
  return (
    <span className={`text-xs font-mono uppercase tracking-wider text-gold ${className}`}>
      {children}
    </span>
  );
}
